<template>
  <div class="module-map-popup">
    <div class="map-popup-wrapper">
      <div class="map-popup__image">
        <img :src="`${apiBase}media/${poi.id}/${brand}/logo.png`" :alt="`${poi.addressLine1} Logo`">
      </div>
      <div class="map-popup__content">
        <div class="content__name">
          <div class="name__name">
            <span>{{ poi.addressLine1 }}</span>
          </div>
          <div class="name__info" v-if="service === 'man'">
            <div class="info__icon icon-info-circle-before" ref="icon" @click.stop="toggleOverlay" @mouseenter="openOverlay" @mouseleave="closeOverlay"></div>
            <div class="info__overlay" :class="{ '-open': showInfoOverlay }" :style="overlayStyles">
              <ul class="-standard-list">
                <li>{{ $t('searchResults.result.info.service.default') }}</li>
                <li>{{ $t('searchResults.result.info.service.man') }}</li>
              </ul>
              <div class="overlay__shape" :style="overlayShapeStyles"></div>
            </div>
          </div>
        </div>
        <div class="content__links">
          <div class="links__link"><a :href="`tel:${poi.phone}`" class="btn -btn-beta" @click="handleTelLink"><span v-if="!showTel">{{ $t('map.popup.links.phone') }}</span><span v-else>{{ poi.phone }}</span></a></div>
          <div class="links__link"><a :href="`https://maps.google.de/?saddr=&daddr=${poi.street}, ${poi.postcode} ${poi.city}, ${poi.country.description}`" target="_blank" class="btn -btn-alpha"><span>{{ $t('map.popup.links.route') }}</span></a></div>
          <div class="links__link"><a :href="`${detailBase}${poi.slug}/?brand=${brand}`"><span>{{ $t('map.popup.links.detail') }}</span></a></div>
        </div>
      </div>
    </div>
    <div class="map-popup__close" @click="$emit('close')"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'GoogleMapPoup',
  inject: ['apiBase', 'detailBase', 'phone'],
  data () {
    return {
      showTel: false,
      showInfoOverlay: false,
      overlayStyles: {},
      overlayShapeStyles: {}
    }
  },
  props: {
    poi: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState({
      brand: state => state.brand
    }),
    service () {
      return this.poi.services.filter(service => service.id === 190).length ? 'man' : 'default'
    }
  },
  methods: {
    handleTelLink (event) {
      if (!this.phone) {
        event.preventDefault()
        this.showTel = !this.showTel
      }
    },
    toggleOverlay () {
      if (this.showInfoOverlay) {
        this.closeOverlay()
      } else {
        this.openOverlay()
      }
    },
    openOverlay () {
      // check if tooltip will overflow window
      const icon = this.$refs.icon
      const dimensions = icon.getBoundingClientRect()
      if (dimensions.left < (150 - (dimensions.width / 2))) {
        // if tooltip would overflow the window on the left side
        // lock the tooltip to the left window boundaries
        this.overlayStyles = { left: (dimensions.left * (-1)) + 'px' }
        this.overlayShapeStyles = { left: dimensions.left + 'px' }
      } else if (window.outerWidth - dimensions.left < (150 + (dimensions.width / 2))) {
        // if tooltip would overflow the window on the right side
        // lock the tooltip to the right window boundaries
        this.overlayStyles = { left: ((window.outerWidth - dimensions.left) - 300) + 'px' }
        this.overlayShapeStyles = { left: (300 - (window.outerWidth - dimensions.left)) + 'px' }
      }
      this.showInfoOverlay = true
    },
    closeOverlay () {
      this.overlayStyles = {}
      this.overlayShapeStyles = {}
      this.showInfoOverlay = false
    }
  }
}
</script>
